<template>
    <div class="flex h-full items-center justify-start">
        <button
            v-if="cancellable"
            class="btn btn-xs"
            :class="loading ? 'loading loading-spinner loading-xs' : 'i-ph-x-circle text-error'"
            title="Avbryt"
            @click.stop="cancel"
        />
        <button
            v-if="paymentStatusOutOfSync"
            :class="refreshLoading ? 'loading loading-spinner loading-xs' : 'i-ph-arrows-clockwise bg-transparent border-none'"
            title="Fiks betalingsstatus"
            @click.stop="refreshPaymentStatus"
        />
    </div>
</template>

<script setup lang="ts">
import {cancelPayment} from '@/bank/payment.service'
import emitter from '@/services/infrastructure/emitter'
import {PAYMENT_UPDATED} from '@/bank/bank.events'
import {ref, computed} from 'vue'
import {ExtendedPendingTransaction} from '@/pending-transaction/pendingTransaction.types'
import {refreshPendingTransactionPaymentStatus} from '@/pending-transaction/pendingTransaction.service'
import {TRANSACTION_CREATED} from '@/types/transaction/TransactionEvent'
import {notifySuccess} from '@/services/infrastructure/notification.service'

const props = defineProps({
    params: {
        type: Object as () => {
            data: ExtendedPendingTransaction
        },
        required: true
    }
})

const loading = ref<boolean>(false)
const refreshLoading = ref<boolean>(false)
const transaction = computed<ExtendedPendingTransaction>(() => {
    return props.params.data
})
const cancellable = computed<boolean>(() => {
    const status = transaction.value.paymentStatus?.toLowerCase()
    return !status || status === 'processing' || status === 'unsigned'
})
const paymentStatusOutOfSync = computed<boolean>(() => {
    return transaction.value.paymentStatus === 'Completed' && transaction.value.status === 'Pending'
})

const cancel = async () => {
    loading.value = true
    const response = await cancelPayment({
        scaRedirectBaseUrl: window.location.href.split('?')[0],
        paymentUuid: transaction.value.paymentUuid
    })
    if (response.scaUrl) window.location.href = response.scaUrl
    else emitter.emit(PAYMENT_UPDATED)
    loading.value = false
}

const refreshPaymentStatus = async () => {
    refreshLoading.value = true
    await refreshPendingTransactionPaymentStatus({
        paymentUuid: transaction.value.paymentUuid
    })
    emitter.emit(PAYMENT_UPDATED)
    emitter.emit(TRANSACTION_CREATED)
    notifySuccess({title: 'Oppdatert', description: `Betalingen "${transaction.value.description}" ble oppdatert.`})
    refreshLoading.value = false
}
</script>

<style scoped>

</style>